











import { Navbar, Sidebar, AppMain, TagsView } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";

import { Component, Vue, Mixins } from "@/common";

@Component({
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView
  },
  mixins: [ResizeMixin]
})
export default class Layout extends Vue {
  get sidebar() {
    return this.$store.state.app.sidebar;
  }
  get classObj() {
    return {
      hideSidebar: !this.sidebar.opened,
      openSidebar: this.sidebar.opened,
      withoutAnimation: this.sidebar.withoutAnimation
    };
  }

  mounted() {
    this.$signalr.on("dynamic.Update", data => {
      console.log(data);
    });
  }
}
